import { GetListRequestParams, GetListResponse, instance } from "libs/api";

import { ApiRoutesEarnings } from "../../constants";
import { EarningsListItem } from "../../financial.types";

export const requestEarnings = async (
  params: GetListRequestParams
): Promise<GetListResponse<EarningsListItem>> => {
  return await instance.get(ApiRoutesEarnings.Earnings, {
    params
  });
};
